<template>
  <div>
    <!-- Navbar start -->
    <navbar-element></navbar-element>
    <!-- Navbar end -->

    <!-- Page content start -->
    <div class="pt-36 px-12 lg:px-32 py-16 max-width-container mx-auto">
      <h1 class="uppercase text-3xl mb-8 font-semibold">Új rendezvénysátor egyesületünknek</h1>

      <div class="text-stone-500 space-y-4 text-justify leading-relaxed">
        <p>
          Örömmel fogadtuk az <a href="https://expodom.hu" target="_blank" rel="noopener noreferrer" class="text-green-600 font-semibold hover:underline">Expodom Kft.</a>
          felajánlását, amelynek köszönhetően egy új <a href="https://www.expodom.hu/articles/rendezvenysator/" target="_blank" rel="noopener noreferrer" class="text-green-600 font-semibold hover:underline">rendezvénysátorral</a> gazdagodott egyesületünk.
          <br />
          A gyorsan felállítható sátor nagy segítséget jelent számunkra a mobil mászófalas rendezvényeken,
          családi napokon, sportprogramokon és nyári táboraink során is. A stabil szerkezetű, könnyen kezelhető
          összecsukható pavilon praktikus megoldást nyújt a változó időjárási körülmények között, miközben kulturált
          és egységes megjelenést biztosít programjainkon.
          <br />
          Tapasztalataink alapján a fém pavilon kiváló minőségű, ezért jó szívvel ajánljuk mindazoknak, akik
          rendezvénysátrat vagy kerti sátrat keresnek közösségi eseményekhez vagy kültéri programokhoz.
          <br />
          Ezúton is köszönjük az Expodom Kft. támogatását!
        </p>
      </div>

      <div class="mt-10 flex justify-center">
        <img
          :src="satorImage"
          alt="3x6 méteres összecsukható rendezvénysátor"
          class="w-full max-w-lg rounded-lg"
        />
      </div>
    </div>
    <!-- Page content end -->

    <!-- Footer start -->
    <footer-element></footer-element>
    <!-- Footer end -->
  </div>
</template>

<script>
import NavbarElement from '@/components/NavbarElement.vue'
import FooterElement from '@/components/FooterElement.vue'

export default {
  name: 'UjRendezvenysatorView',
  components: {
    NavbarElement,
    FooterElement
  },
  data() {
    return {
      satorImage: require('@/assets/images/other/3x6_sator.png')
    }
  }
}
</script>
